import http from '@/util/http';

export default {
	getUserProfile() {
		return http.get('Authorize/api/getUserProfile');
    },
	getUserProfileNotRedirect() {
		return http.get('Authorize/api/getUserProfile', { params: { redirect: 'false' } });
	},
    auth() {
		return http.get('Authorize/api/auth');
	},
}



// WEBPACK FOOTER //
// ./src/api/authorize/authorizeApi.js